<template>
  <div>
    <div v-if="publicKeyAlt" class="mb-small">
      <span class="text-underline text-small">SSH2:</span>
      <ak-box background="grey-lightest" :narrow="true" :rounded="true">
        <code class="public-key">
          {{ publicKeyAlt }}
        </code>
      </ak-box>
    </div>
    <span class="text-underline text-small">OPENSSH:</span>
    <ak-box background="grey-lightest" :narrow="true" :rounded="true">
      <code class="public-key">
        {{ publicKey }}
      </code>
    </ak-box>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'

import Box from '@akerolabs/akero-vue/src/components/box/Box.vue'

export default defineComponent({
  name: 'AkIntegrationSFTPProfilePublicKey',
  components: {
    [Box.name]: Box,
  },
  props: {
    publicKey: {
      required: true,
      type: String,
    },
  },
  setup(props) {
    /**
     * Alternative key format
     * @type {ComputedRef<unknown>}
     */
    const publicKeyAlt = computed(() => {
      const tokens = props.publicKey.split(' ')
      const alg = tokens[0]
      const publicKey = tokens[1]
      return `---- BEGIN SSH2 PUBLIC KEY ----\nComment: "${alg}"\n${publicKey}\n---- END SSH2 PUBLIC KEY ----\n`
    })

    return {
      publicKeyAlt,
    }
  },
})
</script>

<style lang="scss" scoped>
.public-key {
  display: block;
  white-space: pre-wrap;
}
</style>
